import React, { useState, useEffect } from "react";
import { Container, Table } from "react-bootstrap";
import { useHistory } from "react-router";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import FilterSection from "../FilterSection";
import ItemsDash, { ItemsBody } from "../SuperAdminCatalogueView/ItemsDash";
import CategoryHead, { CategoryBody } from "./CategoryHead";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  admin_get_category_menu_setup_date_filter,
  admin_get_items_menu_setup_date_filter,
  get_admin_global_added_templates_date_filter,
  delete_category_menu_setup_admin,
  delete_item_admin_menu_setup,
  update_item_admin_menu_setup,
} from "../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import moment from "moment";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  SET_ACTIVE_CATEGORY_DATA_MENU_SETUP_ADMIN,
  GET_ADMIN_MENU_CATEGORY_ITEMS,
  SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP,
} from "../../../../../store/types";
import AddOnHead, { AddOnBody } from "./AddOnHead";
import AddOnModel from "./AddOnModel";
import AddOn from "./AddOn";
import { SortComponent } from "../../../../reusableComponents/SortAndFilterComponent/SortComponent";
import { SmallLoader } from "../../../../Loader/SmallLoader";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
const SuperAdminGlobalItemsManagement = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const onSuccess = () => {
    setLoading(false);
  };
  const onSuccessItems = () => {};

  const onSuccessDelete = () => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.admin_get_category_menu_setup_date_filter(
      token,
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
      onSuccess
    );
    props.admin_get_items_menu_setup_date_filter(
      token,
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
      onSuccessItems
    );
  };

  const deleteCategory = (id) => {
    const token = props.auth.user.accessToken;
    props.delete_category_menu_setup_admin(id, token, onSuccessDelete);
  };

  const deleteItem = (id) => {
    const token = props.auth.user.accessToken;
    props.delete_item_admin_menu_setup(id, token, onSuccessDelete);
  };

  const takeToCategoryEditPage = () => {
    dispatch({
      type: SET_ACTIVE_CATEGORY_DATA_MENU_SETUP_ADMIN,
      payload: "",
    });
    history.push("/superadmin-global-catalogue/add-category");
  };
  const addNewItem = () => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP, payload: "" });
    dispatch({ type: GET_ADMIN_MENU_CATEGORY_ITEMS, payload: [] });
    history.push("/superadmin-global-catalogue/add-item");
  };

  useEffect(() => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.admin_get_category_menu_setup_date_filter(
      token,
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
      onSuccess
    );
    props.admin_get_items_menu_setup_date_filter(
      token,
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
      onSuccessItems
    );
    props.get_admin_global_added_templates_date_filter(
      token,
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    );
  }, []);
  // var filteredData = props.menuCategory.filter((item) => {
  //   return item.is_global;
  // });
  const filteredCategory = props.menuCategory.filter((item) => {
    return (
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.description.toLowerCase().includes(search.toLowerCase())
    );
  });

  var filteredItems = props.all_menu_items_global.filter((item) => {
    return (
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.description.toLowerCase().includes(search.toLowerCase())
    );
  });

  const filteredTemplates = props.templates.filter((item) => {
    return item.name.toLowerCase().includes(search.toLowerCase());
  });

  const changeItemStatus = (id, status) => {
    const token = props.auth.user.accessToken;
    const formData = { status: !status };
    props.update_item_admin_menu_setup(id, formData, token, onSuccessDelete);
  };

  return (
    <React.Fragment>
      {loading ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row superadmin-pending-chains-vendor">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <GlobalItemsManagement
                  menuCategory={filteredCategory}
                  takeToCategoryEditPage={() => takeToCategoryEditPage()}
                  deleteCategory={(id) => deleteCategory(id)}
                  deleteItem={(id) => deleteItem(id)}
                  search={search}
                  setSearch={(e) => setSearch(e)}
                  items={filteredItems}
                  addNewItem={() => addNewItem()}
                  changeItemStatus={(id, status) =>
                    changeItemStatus(id, status)
                  }
                  templatess={filteredTemplates}
                />
                {/* <GlobalCatalogueDashboard /> */}
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export const GlobalItemsManagement = (props) => {
  const history = useHistory();
  const auth = useSelector((state) => state.auth);
  const [tabStatus, setTabStatus] = useState(
    history?.location?.pathname === "/superadmin-global-items-management/item"
      ? 1
      : history?.location?.pathname ===
        "/superadmin-global-items-management/category"
      ? 2
      : 3
  );

  useEffect(() => {
    setTabStatus(
      history?.location?.pathname === "/superadmin-global-items-management/item"
        ? 1
        : history?.location?.pathname ===
          "/superadmin-global-items-management/category"
        ? 2
        : 3
    );
  }, [history?.location?.pathname]);

  const [addonmodel, setaddonmodel] = useState(false);
  const [data, setData] = useState({
    anchorEl: null,
  });
  const [sortData, setSortData] = useState("A-Z");

  const handleClick = (event) => {
    setData({
      ...data,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setData({
      ...data,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => (e) => {
    setSortData(value);
    handleClose();
  };

  const [foodType, setFoodType] = useState("");
  const [foodTypeData, setFoodTypeData] = useState("");
  const resTypeChangeHandlerAction = (data) => {
    setFoodType(data);
  };

  const [activeItemStatus, setActiveItemStatus] = useState("");
  const [activeStatus, setActive] = useState("");
  const activeItemStatusChangeHandler = (data) => {
    setActiveItemStatus(data);
  };

  const [showFilter, setShowFilter] = useState(false);
  const handleShowFilterOne = (e) => {
    setShowFilter(!showFilter);
  };
  const handleShowFilterClosedOne = (e) => {
    setFoodTypeData(foodType);
    setActive(activeItemStatus);
    setShowFilter(false);
  };

  var filteredGlobalItemsSorted = [];
  if (sortData === "A-Z") {
    filteredGlobalItemsSorted = props.items.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
  } else if (sortData === "Z-A") {
    filteredGlobalItemsSorted = props.items.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return 1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return -1;
      return 0;
    });
  }
  if (foodTypeData !== "") {
    filteredGlobalItemsSorted =
      props.items &&
      props.items.filter(
        (item) => item?.primary_food_type?.title === foodTypeData
      );
  } else if (activeStatus === "active") {
    filteredGlobalItemsSorted =
      props.items && props.items.filter((item) => item?.status === true);
  } else if (activeStatus === "inactive") {
    filteredGlobalItemsSorted =
      props.items && props.items.filter((item) => item?.status === false);
  }

  var filteredGlobalCategorySorted = [];
  if (sortData === "A-Z") {
    filteredGlobalCategorySorted = props.menuCategory.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
  } else if (sortData === "Z-A") {
    filteredGlobalCategorySorted = props.menuCategory.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return 1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return -1;
      return 0;
    });
  }

  var filteredGlobalTemplateSorted = [];
  if (sortData === "A-Z") {
    filteredGlobalTemplateSorted = props.templatess.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
  } else if (sortData === "Z-A") {
    filteredGlobalTemplateSorted = props.templatess.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return 1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return -1;
      return 0;
    });
  }
  const downloadData = {
    headers: [
      { label: "Item ID", key: "id" },
      { label: "Item Name", key: "name" },
      { label: "Item Category", key: "category" },
      { label: "Status", key: "status" },
      { label: "Created Date & Time", key: "dateTime" },
    ],
    data: filteredGlobalItemsSorted
      ? filteredGlobalItemsSorted?.map((ele) => {
          return {
            id: ele?._id,
            name: ele?.name,
            category: `${ele?.primary_food_type?.title} \n ${ele?.category?.name}`,
            status: ele?.status,
            dateTime: `${moment(ele?.createdAt).format("Do MMMM YYYY")} -${moment(ele?.createdAt).format("hh:mm a")}`,
          };
        })
      : [],
  };
 console.log(filteredGlobalItemsSorted?.createdAt,"dateeeee")
  return (
    <Container fluid>
      <div className="d-flex justify-content-between mt-3">
        <div className="row">
          <div className="col-7">
            <div className="f20_700_HelveticaNeue">
              {tabStatus === 1 && "Global Items Management"}
              {tabStatus === 2 && "Global Category Management"}
              {tabStatus === 3 && "Global Add Ons Management"}
            </div>
            <div className="f11-500 opacity5 mt-2">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam,
            </div>
          </div>
        </div>
        <div>
          <button
            className="btn btn-md btn-danger"
            onClick={() => {
              if (tabStatus === 1) {
                // history.push("/superadmin-global-catalogue/add-item");
                props.addNewItem();
              } else if (tabStatus === 2) {
                props.takeToCategoryEditPage();
              } else if (tabStatus === 3) {
                setaddonmodel(true);
              }
            }}
          >
            {tabStatus === 1 && "+ Add New Item"}
            {tabStatus === 2 && "+ Add New Global Category"}
            {tabStatus === 3 && "+ Add New"}
          </button>
        </div>
      </div>
      <div>
        <FilterSection
          tabStatus={tabStatus}
          search={props.search}
          onChange={(e) => props.setSearch(e)}
          sortFilter={
            <SortComponent
              handleClick={handleClick}
              anchorEl={data.anchorEl}
              handleClose={handleClose}
              selectClick={(data) => handleSelect(data)}
            />
          }
          resType={foodType}
          resTypeChangeHandler={(data) => resTypeChangeHandlerAction(data)}
          showFilter={showFilter}
          handleShowFilter={handleShowFilterOne}
          handleShowFilterClosed={handleShowFilterClosedOne}
          itemStatus={activeItemStatus}
          itemStatusChangeHandler={(data) =>
            activeItemStatusChangeHandler(data)
          }
          downloadreport={
                       <CSVDownloader
                        filename={"Global-Items-Management-Report"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                      }
        />
      </div>
      <div className="mt-3 d-flex">
        <div
          className={`mr-3 f12-500 ${
            tabStatus === 1 ? `selected-global-catalogue` : `opacity5`
          }`}
          style={{ cursor: "pointer" }}
          onClick={() => {
            setTabStatus(1);
            history.push("/superadmin-global-items-management/item");
          }}
        >
          Items
        </div>
        <div
          style={{ cursor: "pointer" }}
          className={`ml-4 f12-500 mr-3 ${
            tabStatus === 2 ? `selected-global-catalogue` : `opacity5`
          }`}
          onClick={() => {
            setTabStatus(2);
            history.push("/superadmin-global-items-management/category");
          }}
        >
          Category
        </div>
        <div
          style={{ cursor: "pointer" }}
          className={`f12-500 ml-4 ${
            tabStatus === 3 ? `selected-global-catalogue` : `opacity5`
          }`}
          onClick={() => {
            setTabStatus(3);
            history.push("/superadmin-global-items-management/addons");
          }}
        >
          Add Ons
        </div>
      </div>
      {tabStatus === 1 && (
        <div className="col-12 p-0  user-table-reusable-superadmin ">
          <Table>
            <thead>
              <ItemsDash />
            </thead>
            {auth.secondary_loader ? (
              <SmallLoader />
            ) : (
              filteredGlobalItemsSorted.map((item, index) => (
                <ItemsBody
                  key={index}
                  item={item}
                  deleteItem={() => props.deleteItem(item._id)}
                  changeItemStatus={() =>
                    props.changeItemStatus(item._id, item.status)
                  }
                />
              ))
            )}
          </Table>
        </div>
      )}
      {tabStatus === 2 && (
        <div className="col-12 p-0  user-table-reusable-superadmin ">
          <Table>
            <thead>
              <CategoryHead />
            </thead>
            {auth.secondary_loader ? (
              <SmallLoader />
            ) : (
              filteredGlobalCategorySorted.map((item, index) => (
                <CategoryBody
                  deleteCategory={() => props.deleteCategory(item._id)}
                  key={index}
                  item={item}
                />
              ))
            )}
          </Table>
        </div>
      )}
      {tabStatus === 3 && (
        <>
          {auth.secondary_loader ? (
            <SmallLoader />
          ) : (
            <AddOn
              templates={filteredGlobalTemplateSorted}
              open={addonmodel}
              setaddonmodel={setaddonmodel}
            />
          )}
          {/* <div className="col-12 p-0  user-table-reusable-superadmin ">
            <Table>
              <thead>
                <AddOnHead />
              </thead>

              <AddOnBody />
            </Table>
          </div>
          <AddOnModel open={addonmodel} setaddonmodel={setaddonmodel} /> */}
        </>
      )}
    </Container>
  );
};

SuperAdminGlobalItemsManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  delete_category_menu_setup_admin: PropTypes.func.isRequired,
  admin_get_category_menu_setup_date_filter: PropTypes.func.isRequired,
  admin_get_items_menu_setup_date_filter: PropTypes.func.isRequired,
  update_item_admin_menu_setup: PropTypes.func.isRequired,
  get_admin_global_added_templates_date_filter: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  menuCategory: state.commonSuperAdmin.menuCategory,
  all_menu_items_global: state.commonSuperAdmin.all_menu_items_global,
  templates: state.commonSuperAdmin.admin_global_templates,
});

export default connect(mapStateToProps, {
  admin_get_category_menu_setup_date_filter,
  admin_get_items_menu_setup_date_filter,
  get_admin_global_added_templates_date_filter,
  delete_category_menu_setup_admin,
  delete_item_admin_menu_setup,
  update_item_admin_menu_setup,
})(SuperAdminGlobalItemsManagement);
